export interface LinkCellProps {
  text: JSX.Element | string
  url: string
  openInNewTab?: boolean
}

const LinkCell = ({ text, url, openInNewTab = false }: LinkCellProps) => {
  const attributes: { href: string, target?: string, rel?: string } = {
    href: url
  }

  if (openInNewTab) {
    attributes.target = '_blank'
    attributes.rel = 'noreferrer'
  }

  return (<a {...attributes}>{text}</a>)
}

export default LinkCell
